// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3n44j","header":"ReportDetails_header__sGdjN","title":"ReportDetails_title__kGxGb","left":"ReportDetails_left__3HY7R"};